import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Referral } from "../../../domain/entities/referral";
import { type ReferralsDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listReferrals = createAsyncThunk<
  Referral[],
  string,
  { dispatch: ReferralsDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_REFERRALS, async (requestId, { extra }) => {
  return await extra.referralsRepo.listReferrals(requestId);
});
